import { compose, lifecycle, withHandlers, withState } from 'recompose';
import { connect } from 'react-redux';

import { getKickbackById, saveKickback } from 'actions/loyalties';
import { showLoading, hideLoading } from 'actions/ui';

import { routerPassId, hideIfNoData } from 'utils/enhancers';
import { wrapWithSideEffect } from 'utils';

import KickbackDetailsPage from './KickbackDetailsPage';

const mapDispatchToProps = {
  onInit: getKickbackById,
  onSave: saveKickback,
  showLoading,
  hideLoading,
};

const state = compose(withState('initialData', 'setInitialData'));

const wrapWithProgress = (props) => (promise) => {
  return wrapWithSideEffect(props.showLoading)(promise).finally(
    props.hideLoading
  );
};

const refresh = (props) => {
  const { id, onInit, setInitialData } = props;
  return wrapWithProgress(props)(onInit(id).then(setInitialData));
};

const handlers = withHandlers({
  onInit: (props) => () => refresh(props),
  onSave: (props) => (event) => {
    return wrapWithProgress(props)(
      props.onSave(event).then((data) => {
        if (!props.id) {
          props.history.push(`/kickback-details/${data.id}`);
        }
        refresh({ ...props, id: data.id });
      })
    );
  },
});

const retrieveData = lifecycle({
  componentDidMount() {
    const { id, onInit } = this.props;
    if (id) {
      onInit(id);
    }
  },
});

export default compose(
  routerPassId,
  connect(
    null,
    mapDispatchToProps
  ),
  state,
  handlers,
  retrieveData,
  hideIfNoData((props) => props.id && !props.initialData)
)(KickbackDetailsPage);
